import styled from 'styled-components';
import { Flex } from '../../Layout';
import { TypographyBase } from '../../Typography';
export const OptionsContainer = styled(Flex).withConfig({
  displayName: "OptionsContainer",
  componentId: "sc-1i4wa1g-0"
})(["flex-direction:column;z-index:9999;"]);
export const FlagContainer = Flex;
export const Flag = TypographyBase;
export const TriggerWrapper = styled(Flex).withConfig({
  displayName: "TriggerWrapper",
  componentId: "sc-1i4wa1g-1"
})(["align-items:baseline;min-width:36px;&&&{:hover{cursor:pointer;}}"]);
export const CountryOption = styled.div.attrs(props => ({
  style: {
    height: "".concat(props.size - 24, "px}"),
    transform: "translateY(".concat(props.start, "px)"),
    width: props.innerWidth
  }
})).withConfig({
  displayName: "CountryOption",
  componentId: "sc-1i4wa1g-2"
})(["position:absolute;top:0;left:0;margin:12px;display:flex;align-items:center;font-family:inherit;&&&{:hover{cursor:pointer;}}"]);